import { render, staticRenderFns } from "./DnaBudgetsDetailPage.vue?vue&type=template&id=5ff63b96&"
import script from "./DnaBudgetsDetailPage.vue?vue&type=script&lang=js&"
export * from "./DnaBudgetsDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DnaBudgetsDetailPage.vue?vue&type=style&index=0&id=5ff63b96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports